import styled from 'styled-components';

export const GoogleMapContainer = styled.div`
  height: 100%;
  width: 100%;
`;
